import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import useNear from "../hooks/nearHook";
import useSbt from "../hooks/sbtHook";
import useApi from "../hooks/apiHook";
import useTokenRouting from "../hooks/tokenRoutingHook";
import Typography from "@mui/material/Typography";
import ReactJson from "react-json-view";
import SbtMetadataTable from "../components/SbtMetadataTable";
import SbtSelector from "../components/SbtSelector";
import SbtTokenListTable from "../components/SbtTokenListTable";
import AccountField from "../components/AccountField";
import SbtPermissionSelector from "../components/SbtPermissionSelector";

const SbtDashboard = () => {
  const near = useNear();
  const sbt = useSbt();
  const apiFactory = useApi();
  const [authContract, setAuthContract] = useState("");

  const [sbtMetadata, setSbtMetadata] = useState({});
  const [sbtTokens, setSbtTokens] = useState([]);
  const [tokenContents, setTokenContents] = useState({});
  const {
    contractId,
    accountId,
    selectedTokenId,
    setContractId,
    setAccountId,
    setSelectedTokenId,
  } = useTokenRouting();

  useEffect(() => {
    if (!near.account.account) {
      return;
    }
    if (!contractId) {
      setSbtMetadata({});
    }
    sbt.getContractMetadata(contractId).then((result) => {
      setSbtMetadata(result || {});
      if (!result && selectedTokenId) {
        setSelectedTokenId(null);
      }
    });
  }, [contractId, near.account.account]);

  useEffect(() => {
    if (!contractId || !accountId || !near.account.account) {
      setSbtTokens([]);
      return;
    }
    sbt.getSbtTokensForAccount(contractId, accountId).then((result) => {
      setSbtTokens(result);
      if (
        (!result.length || !result.find((t) => t.id === selectedTokenId)) &&
        selectedTokenId
      ) {
        setSelectedTokenId(null);
      }
    });
    setTokenContents({});
  }, [contractId, accountId, near.account.account]);

  useEffect(() => {
    setTokenContents({});
  }, [selectedTokenId]);

  useEffect(() => {
    if (!accountId) {
      setAccountId(near.account.account);
    }
  }, [near.account.account]);

  const getTokenContents = (tokenId) => {
    if (!sbtMetadata) {
      return;
    }
    if (!tokenId) {
      return;
    }

    const api = apiFactory.getApi(sbtMetadata.base_uri);

    api.getSbt(tokenId, authContract || null).then(setTokenContents);

    console.log(sbtMetadata.base_uri, tokenId);
    // setTokenContents({mock: "data", token_id: tokenId})
    // TODO: call API
  };

  const selectedToken = sbtTokens.find((t) => t.id === selectedTokenId);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            <SbtSelector
              sbtContractId={contractId}
              setSbtContractId={setContractId}
            />
            <SbtMetadataTable sbtMetadata={sbtMetadata} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            <AccountField accountId={accountId} setAccountId={setAccountId} />
            <SbtTokenListTable
              sbtTokens={sbtTokens}
              onSelect={setSelectedTokenId}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={5}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 800,
            }}
          >
            <Typography variant="h6">Selected token</Typography>
            <ReactJson
              src={selectedToken}
              name={false}
              style={{ overflow: "auto" }}
              enableClipboard={false}
              onSelect={(e) => {
                if (e.name === "parent_id" && e.value) {
                  setSelectedTokenId(e.value);
                }
              }}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 800,
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={8}>
                <SbtPermissionSelector
                  sbtAuthContractId={authContract}
                  setSbtAuthContractId={setAuthContract}
                />
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => getTokenContents(selectedTokenId)}
                >
                  Get Contents
                </Button>
              </Grid>
            </Grid>
            <ReactJson
              src={tokenContents}
              name={false}
              style={{ overflow: "auto" }}
              enableClipboard={false}
            />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SbtDashboard;
